import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { store, StoreContext } from 'src/integration/store/store';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import queryClientConfig from 'src/integration/config/queryClientConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClient = new QueryClient(queryClientConfig);

root.render(
  <React.StrictMode>
    <StoreContext.Provider value={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
      </QueryClientProvider>
    </StoreContext.Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
